import { render } from "./CouponPopup.vue?vue&type=template&id=6556cf34&ts=true"
import script from "./CouponPopup.vue?vue&type=script&lang=ts"
export * from "./CouponPopup.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__